var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrandStrategicPlans(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_623_1567)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.7966 25.6962L69.2381 18.8997L68.6944 12.8584L61.2529 19.6377L61.7966 25.6962Z",
    stroke: "#0091C4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.1507 20.0665L67.7093 26.8629L61.7969 25.6959L69.2383 18.8994L75.1507 20.0665Z",
    stroke: "#0091C4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7178 46L63.2922 24.4258",
    stroke: "#0091C4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5569 50.6337C38.2147 50.6337 37.1104 49.5353 37.1104 48.1794C37.1104 46.8236 38.1977 45.708 39.5569 45.708C40.916 45.708 41.9864 46.8064 41.9864 48.1794C41.9864 49.5525 40.899 50.6337 39.5569 50.6337Z",
    stroke: "#0091C4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5956 26.6398C51.1273 23.2416 45.5887 21.1992 39.5573 21.1992C24.8103 21.1821 12.8496 33.2647 12.8496 48.162C12.8496 63.0593 24.8103 75.1419 39.5573 75.1419C54.3043 75.1419 66.2651 63.0593 66.2651 48.162C66.2651 42.2751 64.3792 36.8345 61.2021 32.3894",
    stroke: "#0091C4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8359 36.8006C58.9426 40.0787 60.1999 43.9746 60.1999 48.1623C60.1999 59.6614 50.9405 69.0151 39.5575 69.0151C28.1744 69.0151 18.915 59.6614 18.915 48.1623C18.915 36.6633 28.1744 27.3096 39.5575 27.3096C43.9068 27.3096 47.9334 28.6826 51.2633 30.9996",
    stroke: "#0091C4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7461 45.9824C47.933 46.686 48.0519 47.4069 48.0519 48.162C48.0519 52.899 44.2293 56.7606 39.5401 56.7606C34.851 56.7606 31.0283 52.899 31.0283 48.162C31.0283 43.4251 34.851 39.5635 39.5401 39.5635C40.5085 39.5635 41.409 39.7694 42.2755 40.0612",
    stroke: "#0091C4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8292 35.4789C44.6715 34.2088 42.208 33.4365 39.5576 33.4365C31.5215 33.4365 24.9805 40.0442 24.9805 48.1622C24.9805 56.2802 31.5215 62.8878 39.5576 62.8878C47.5937 62.8878 54.1347 56.2802 54.1347 48.1622C54.1347 45.6736 53.4551 43.3738 52.3848 41.3142",
    stroke: "#0091C4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_623_1567"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandStrategicPlans);
export default __webpack_public_path__ + "static/media/brand-strategic-plans.52a39c782d37a82a1a07deeff65d29f0.svg";
export { ForwardRef as ReactComponent };